import React from "react";

const BackUp = () => {
  return <div>BackUp</div>;
};

export default BackUp;
